import { render } from "./LineChart.vue?vue&type=template&id=2f42e9d9"
import script from "./LineChart.vue?vue&type=script&lang=js"
export * from "./LineChart.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__